import { CommandeAnalyse } from './types';

// Montants d'une offre. Deux notions distinctes, conformes au legacy :
//  - le montant AFFICHE dans la grille = somme des prix d'articles (totalHT) ;
//  - le montant de SCORING de secours = le champ backend prix_total.
// Le score financier autoritaire vient du backend (note_financiere, cf. scoring.ts) ;
// ces montants ne servent qu'a l'affichage et au calcul de secours.

const toNumber = (value: number | string | null | undefined): number => {
  if (value === null || value === undefined) return 0;
  const n = typeof value === 'number' ? value : parseFloat(value);
  return Number.isNaN(n) ? 0 : n;
};

// Somme a plat des prix d'articles sur toutes les sections (aucune quantite, aucun sous-total).
export const getMontantAffiche = (commande: CommandeAnalyse): number => {
  let total = 0;
  (commande.sections || []).forEach((section) => {
    (section.articles || []).forEach((article) => {
      total += toNumber(article?.prix);
    });
  });
  return total;
};

// Montant utilise par le calcul de secours du score financier (champ backend prix_total).
// Renvoie undefined si absent -> l'offre n'entre pas dans le pool de scoring de secours.
export const getMontantScoring = (commande: CommandeAnalyse): number | undefined => {
  if (commande.prix_total === null || commande.prix_total === undefined) return undefined;
  return toNumber(commande.prix_total);
};
